module.exports = __webpack_public_path__ + "img/man_menu.f02ff47b.svg";